export const checkboxControlLabelStyle = {
  fontSize: '1rem',
  color: 'rgba(0, 0, 0, 0.6)',
};

export const burgerCheckboxStyle = {
  color: 'rgba(0, 0, 0, 0.6)',
};
